export default [
    '+375',
    '+7'
];



// WEBPACK FOOTER //
// ./src/constants/phone-prefix.js